import React, { useEffect } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  /** 自动关闭延时（毫秒），默认 6000 */
  duration?: number;
}

/**
 * 验证码发送后的提示弹窗，停留一段时间后自动关闭。
 * 提醒用户检查垃圾邮件夹（邮件验证码常被误判）。
 */
export const CodeSentToast: React.FC<Props> = ({ open, onClose, duration = 6000 }) => {
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [open, duration, onClose]);

  if (!open) return null;

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50 w-[min(420px,92vw)]">
      <div className="flex items-start gap-3 bg-white border border-primary-200 rounded-xl shadow-lg px-4 py-3">
        <span className="text-lg leading-none mt-0.5">📩</span>
        <div className="flex-1 text-sm text-gray-700 leading-snug">
          Verification code sent. If you don't see it in your inbox, please check your spam or junk folder.
        </div>
        <button
          onClick={onClose}
          className="shrink-0 text-gray-400 hover:text-gray-600 text-sm leading-none"
          aria-label="Close"
        >
          ✕
        </button>
      </div>
    </div>
  );
};
